// extracted by mini-css-extract-plugin
export var button = "_bz-7";
export var buttonRow = "_bz-6";
export var fadeIn = "_bz-1";
export var gradient = "_bz-0";
export var panel = "_bz-2";
export var panelIn = "_bz-3";
export var subtitle = "_bz-5";
export var title = "_bz-4";